var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-flex rhe-table"},[_c('div',{staticClass:"u-flex"},_vm._l((_vm.list),function(index,key){return _c('div',{key:key,staticClass:"rhe-tb-item pot",class:{
        'tab-right-none': key == 0 ,
        'left-none': _vm.isLenght(key),
        pitch: key == _vm.check,
      },attrs:{"id":`tab${key}`},on:{"click":function($event){return _vm.tabclick(key, index)}}},[_vm._v("\n      "+_vm._s(index)+"\n    ")])}),0),_c('div',{staticClass:"botton-line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }